import React from 'react';
import { motion } from 'framer-motion';

function CookiePolicy() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="min-h-screen bg-gray-50 py-12"
    >
      <div className="container mx-auto px-4 max-w-3xl">
        <div className="bg-white rounded-xl shadow-lg p-8">
          <h1 className="text-3xl font-bold mb-6">Çerez Politikası</h1>
          
          <div className="prose prose-blue max-w-none">
            <p className="text-gray-600 mb-6">
              Son güncelleme tarihi: {new Date().toLocaleDateString('tr-TR')}
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">Çerezler Hakkında</h2>
            <p>
              Excel Vadisi olarak, web sitemizde deneyiminizi geliştirmek için çerezleri kullanmaktayız. 
              Bu politika, hangi çerezleri kullandığımızı ve bunları nasıl kontrol edebileceğinizi açıklamaktadır.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">Çerez Türleri</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>
                <strong>Zorunlu Çerezler:</strong> Sitenin çalışması için gerekli olan temel çerezlerdir.
              </li>
              <li>
                <strong>Analitik Çerezler:</strong> Sitemizin kullanımını analiz etmek için kullanılır.
              </li>
              <li>
                <strong>İşlevsel Çerezler:</strong> Tercihlerinizi hatırlamak için kullanılır.
              </li>
            </ul>

            <h2 className="text-xl font-semibold mt-8 mb-4">Çerezleri Nasıl Kontrol Edebilirsiniz?</h2>
            <p>
              Tarayıcınızın ayarlarından çerezleri kontrol edebilir veya silebilirsiniz. 
              Ancak, bazı çerezleri devre dışı bırakmanın sitemizin işlevselliğini etkileyebileceğini unutmayın.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">Çerez Kullanım Amaçlarımız</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Kullanıcı oturumlarını yönetmek</li>
              <li>Site performansını analiz etmek</li>
              <li>Kullanıcı deneyimini iyileştirmek</li>
              <li>Güvenliği sağlamak</li>
            </ul>

            <h2 className="text-xl font-semibold mt-8 mb-4">İletişim</h2>
            <p>
              Çerez politikamız hakkında sorularınız için{' '}
              <a 
                href="https://www.instagram.com/excelvbamakro/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-blue-600 hover:text-blue-800 inline-flex items-center"
              >
                Instagram hesabımız
                <svg className="w-4 h-4 ml-1" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z" />
                  <path d="M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z" />
                </svg>
              </a>{' '}
              üzerinden bizimle iletişime geçebilirsiniz.
            </p>
          </div>
        </div>
      </div>
    </motion.div>
  );
}

export default CookiePolicy; 